import { useQuery } from "@tanstack/react-query";
import { getReportPaymentBreakdown } from "../../api/apiReports";

export const useGetReportPaymentBreakdown = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-payment-breakdown", params],
        queryFn: () => getReportPaymentBreakdown(params),
        retry: false,
    });

    return {
        items: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
